<template>
  <v-app-bar
      elevation="0"
      class="main-header"
      height="64"
      fixed
      color='white'
      dark
  >
    <v-btn icon class="d-flex d-sm-none" color="primary" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">arrow_back</v-icon>
      </template>
      <template v-else>
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>
      <router-link :to="gotoHome">
        <v-img v-if="customer.logoUrl === null" height="25" contain src="@/assets/logo-viewelevator-blue.png"></v-img>
        <v-img v-else height="25" contain :src="getPath()"></v-img>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="header-links d-none d-sm-flex ml-10">
        <v-btn
            v-for="(item, i) in checkRolesAndMain(navLinks)"
            :key="i"
            text
            active-class="navbar-link--active"
            :to="item.route"
            class="text-capitalize primary--text"
        >
          {{ $t('book/navbar:links.' + item.text) }}
        </v-btn>

      <v-menu
          v-if="isAdmin"
          min-width="180"
          offset-y
          bottom
          nudge-bottom="14"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize primary--text"
          >
            {{ $t('book/navbar:admin') }}
            <v-icon class="ml-1">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item
                v-for="(item, i) in adminLinks"
                :key="i"
                :to="item.route"
                link
                @click="item.action ? item.action() : null"
            >
              <v-list-item-action class="mr-2" v-if="item.icon">
                <v-icon class="greyTint--text">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('book/navbar:adminLinks.' + item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu
          v-if="isManager"
          min-width="180"
          offset-y
          bottom
          nudge-bottom="14"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize primary--text"
          >
            {{ $t('book/navbar:global-documentations') }}
            <v-icon class="ml-1">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <template v-for="(item, i) in globalDocumentationLinks">
              <v-list-item
                v-if="item"
                :key="i"
                :to="item.route"
                link
                @click="item.action ? item.action() : null"
              >
                <v-list-item-action class="mr-2" v-if="item.icon">
                  <v-icon class="greyTint--text">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-if="item.text">
                    {{ $t('book/navbar:global-docu-links.' + item.text) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-else :key="i"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>

    <!-- TODO uncomment search component if needed in future -->
    <!-- <v-spacer></v-spacer>

    <Search/> -->

    <UserMenu
        :user="user"
    />

    <!-- LanguageSelector -->
    <LanguageMenu />

    <!-- Notifications -->
    <!-- TODO uncomment if needed later -->
    <!-- <v-menu
        min-width="180"
        offset-y
        bottom
        left
        nudge-bottom="10"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            style="font-size: 28px"
            icon
            class="mr-3"
        >
          <v-icon
              size="28"
          >
            notifications
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">Nachrichten</div>
        <v-list-item-group color="primary">
          <v-list-item>Some Message</v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu> -->
  </v-app-bar>
</template>

<script>
import {Role} from '@/modules/core/data/roles';

import {mapActions, mapState} from 'vuex';
import config from '@/config';
import store from '@/store';
import UsersService from '@/modules/core/services/users-service';
import DataUtils from '@/modules/core/services/data-utils';
import Users from '@/modules/core/data/users';
import UserMenu from '@/modules/core/components/Header/UserMenu';
import LanguageMenu from '@/modules/core/components/Header/LanguageMenu';
import ModuleSwitcher from '@/plugins/module-switcher';
import Customer from '@/modules/core/data/customer';
import CustomerService from '@/modules/core/services/customer-service';

// TODO uncomment search component if needed in future
// import Search from '@/modules/core/components/Search/Search'
const URL_PREFIX = '/' + store.state.manager.bookModuleUrl;

export default {
  name: 'BookHeader',
  components: {
    // TODO uncomment search component if needed in future
    // Search
    UserMenu,
    LanguageMenu
  },
  data: () => ({
    config,
    searchCollapse: true,
    ownsDisplay: true, //may access the media instance
    messageBadge: true,
    user: [],
    customer: {},
    globalDocumentationLinks: [
      {text: 'contracts', route: URL_PREFIX + '/global/contract', icon: 'receipt_long', main: false, roles: [Role.Admin, Role.Manager]},
      {text: 'documentations', route: URL_PREFIX + '/global/documentation', icon: 'receipt_long', main: false, roles: [Role.Admin, Role.Manager]},
      null, // divider
      {text: 'gbu-export', route: URL_PREFIX + '/gbu-export', icon: 'import_export', main: false, roles: [Role.Admin, Role.Operator, Role.Manager]},
    ],
    adminLinks: [
      {
        icon: 'build',
        text: 'roles',
        route: URL_PREFIX + '/admin/worker-role',
        main: false
      },
      {
        icon: 'filter',
        text: 'parameter',
        route: URL_PREFIX + '/admin/parameter',
        main: false
      },
      {
        icon: 'line_weight',
        text: 'process',
        route: URL_PREFIX + '/admin/process/base',
        main: false
      },
      {
        icon: 'line_style',
        text: 'processSteps',
        route: URL_PREFIX + '/admin/process/steps',
        main: false
      },
      {
        icon: 'question_answer',
        text: 'processAnswers',
        route: URL_PREFIX + '/admin/process/answer',
        main: false
      },
      {
        icon: 'qr_code',
        text: 'qrcode',
        route: URL_PREFIX + '/admin/qrcode',
        main: false
      },
      {
        icon: 'import_export',
        text: 'import',
        route: URL_PREFIX + '/admin/import',
        main: false
      },
      {
        icon: 'storage',
        text: 'testdata',
        route: URL_PREFIX + '/admin/testdata',
        main: false
      },
      {
        icon: 'account_tree',
        text: 'facility-type',
        route: URL_PREFIX + '/admin/facility-type',
        main: false
      },
      {
        icon: 'description',
        text: 'documentation-rule',
        route: URL_PREFIX + '/admin/documentation-rule',
        main: false
      }
    ]
  }),
  computed: {
    // Template
    ...mapState('book/layout',
        {drawer: state => state.drawer}
    ),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    },
    isManager() {
      return this.$store.getters['auth/isManager'];
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    gotoHome() {
      return !this.hasRole([Role.Admin]) && ModuleSwitcher.isOnlyLiftBook()
          ? `/${this.$store.state.manager.bookModuleUrl}` : '/home';
    },
    navLinks() {
      let navLinks = [
        {text: 'buildings', route: URL_PREFIX + '/buildings', main: false, roles: [Role.Admin, Role.Operator]},
        {text: 'facilities', route: URL_PREFIX + '/facilities', main: false, roles: [Role.Admin, Role.Operator, Role.Manager]},
        {text: 'processes', route: URL_PREFIX + '/processes', main: false, roles: [Role.Admin, Role.Operator, Role.Manager, Role.Worker]}
      ];

      if (window.innerWidth > 599) {
        navLinks.push({text: 'issue-board', route: URL_PREFIX + '/issue-board', main: false, roles: [Role.Admin]});
      }

      return navLinks;
   }
  },
  methods: {
    // Template
    ...mapActions('book/layout', ['TOGGLE_DRAWER']),

    getPath() {
      if (this.customer === undefined || this.customer.logoUrl === undefined)
        return;

      return process.env.VUE_APP_ROOT_HOST + this.customer.logoUrl + "?" + Math.random();
    },

    checkRolesAndMain(links) {
      let self = this;
      return links.filter(function (link) {
        return (!link.main || (link.main && self.isMain))
            && self.hasRole(link.roles);
      })
    },
    hasRole(roles) {
      if (!roles) return true;
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < roles.length; i++) {
          if (this.currentUser.roles.includes(roles[i])) {
            return true;
          }
        }
      }
      return false;
    }
  },
  created() {
    if (this.$store.state.auth.profile) {
      this.user = this.$store.state.auth.profile;
      CustomerService.readProfileFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
            this.customer = response;
          })
    } else {
      UsersService.readProfileFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Users);
            if (response == null) {
              this.$logger.error("Failed to receive user data!");
            } else {
              this.user = response;
              CustomerService.readProfileFromAPI(
                  (resp) => {
                    var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
                    this.customer = response;
                  })
            }
        }
      );
    }
  }
};
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>
